import { Box, useTheme } from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { StyledAvatarBox, StyledAccountIcon } from './EmptyUserAvatar.styles';

export const EmptyUserAvatar = (props: { color: string, fontSize: string, padding: string }) => {
    return (
        <StyledAvatarBox $padding={props.padding}>
            <StyledAccountIcon $fontSize={props.fontSize} $color={props.color} />
        </StyledAvatarBox>
    );
}